import {first, last} from 'lodash';
import moment from 'moment';
import styles from '../qualityIndicator/QualityIndicator.module.scss';
import LineChart from '../../shared/charts/LineChart';

const QualitativeChart = ({
  results = [],
  plausibleLow,
  toleranceLow,
  warningLow,
  warningHigh,
  toleranceHigh,
  plausibleHigh,
  desiredValue,
}) => {
  const series = results.map((r) => ({
    x: moment(r.createdAt).valueOf(),
    y: r.overruledUserId ? Number(r.overruledValue) : Number(r.value),
  }));
  const minDate = moment(first(results)?.createdAt).valueOf();
  const maxDate = moment(last(results)?.createdAt).valueOf();

  const plotBands = [];

  let low = plausibleLow;

  if (toleranceLow !== null) {
    plotBands.push({
      from: low,
      to: toleranceLow,
      color: styles.bgBad,
    });
    low = toleranceLow;
  }

  if (warningLow !== null) {
    plotBands.push({
      from: low,
      to: warningLow,
      color: styles.bgWarn,
    });
    low = warningLow;
  }

  if (toleranceLow === null && warningLow === null) {
    plotBands.push({
      from: low,
      to: desiredValue,
      color: styles.bgBad,
    });
  } else {
    plotBands.push({
      from: low,
      to: desiredValue,
      color: styles.bgGood,
    });
  }

  let high = plausibleHigh;

  if (toleranceHigh !== null) {
    plotBands.push({
      from: toleranceHigh,
      to: high,
      color: styles.bgBad,
    });
    high = toleranceHigh;
  }

  if (warningHigh !== null) {
    plotBands.push({
      from: warningHigh,
      to: high,
      color: styles.bgWarn,
    });
    high = warningHigh;
  }

  if (toleranceHigh === null && warningHigh === null) {
    plotBands.push({
      from: desiredValue,
      to: high,
      color: styles.bgBad,
    });
  } else {
    plotBands.push({
      from: desiredValue,
      to: high,
      color: styles.bgGood,
    });
  }

  return (
    <LineChart
      options={{
        series: [{
          data: series,
          color: 'black',
        }],
        legend: {enabled: false},
        title: {text: ''},
        xAxis: {
          min: minDate,
          max: maxDate,
        },
        yAxis: {
          title: false,
          min: plausibleLow,
          max: plausibleHigh,
          plotBands,
        },
      }}
      isTimeseries
    />
  );
};
export default QualitativeChart;
